import ReProfile from './re-profile'
Vue.component(ReProfile.name, ReProfile)

import ReProfileViewEdit from './re-profile-view-edit'
Vue.component(ReProfileViewEdit.name, ReProfileViewEdit)

import ReProfileEdit from './re-profile-edit'
Vue.component(ReProfileEdit.name, ReProfileEdit)

import ReProfileResetPassword from './re-profile-reset-password'
Vue.component(ReProfileResetPassword.name, ReProfileResetPassword)

import ReProfileGiftcards from './re-profile-giftcards'
Vue.component(ReProfileGiftcards.name, ReProfileGiftcards)

import ReProfilePlaycards from './re-profile-playcards'
Vue.component(ReProfilePlaycards.name, ReProfilePlaycards)

import ReProfileCards from './re-profile-cards'
Vue.component(ReProfileCards.name, ReProfileCards)

import ReProfileSettings from './re-profile-settings'
Vue.component(ReProfileSettings.name, ReProfileSettings)

export default {
  ReProfile,
  ReProfileEdit,
  ReProfileResetPassword,
  ReProfileGiftcards,
  ReProfilePlaycards,
  ReProfileCards,
  ReProfileSettings
}
